import { toast } from 'react-toastify';

import { apiSlice } from '../apiSlice';
import invalidateTags from '../invalidateTags';
import axios from '../../utils/axios';

export const tags = {
  messages: 'messages',
};

const messagesApi = apiSlice
  .enhanceEndpoints({ addTagTypes: Object.values(tags) })
  .injectEndpoints({
    endpoints: (build) => ({

      getMessages: build.query({
        queryFn: async ({ application_uuid }, api) => {
          // Fixes polling issue where one more request is sent out after logging out
          if (!api.getState().auth.isLoggedIn) return { data: [] };
          try {
            const response = await axios({
              url: `${baseURL}/communications/${application_uuid}`,
              method: 'GET',
            });
            return { data: response.data };
          } catch (error) {
            console.error(error.response);
            return { error };
          }
        },
        providesTags: [tags.messages],
      }),

      sendMessages: build.mutation({
        queryFn: async ({ application_uuid, data, setSubmitting, cb }) => {
          try {
            const response = await axios({
              url: `${baseURL}/communications/${application_uuid}`,
              method: 'POST',
              data,
            });
            toast.success('Sent!');
            cb();
            setSubmitting();
            return { data: response.data };
          } catch (error) {
            console.error(error.response);
            setSubmitting();
            return { error };
          }
        },
        invalidatesTags: invalidateTags([...Object.values(tags)]),
      }),

      sendReadReceipts: build.mutation({
        queryFn: async ({ application_uuid, read_receipt_uuids }) => {
          try {
            const response = await axios({
              url: `${baseURL}/communications/read/${application_uuid}`,
              method: 'POST',
              data: { read_receipt_uuids },
            });
            return { data: response.data };
          } catch (error) {
            console.error(error.response);
            return { error };
          }
        },
        invalidatesTags: invalidateTags([...Object.values(tags)]),
      }),
    }),
  });

export const {
  useGetMessagesQuery,
  useSendMessagesMutation,
  useSendReadReceiptsMutation,
} = messagesApi;
